var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"p-3 border-t hover:bg-blue-lighter cursor-pointer",class:{'bg-grey': !_vm.isAvailable,
            'bg-blue-lightest': _vm.isSelected,
            },style:(_vm.padding),on:{"click":function($event){return _vm.click()}}},[_c('span',{class:{'bg-grey': !_vm.isAvailable}},[_c('i',{staticClass:"fa fa-fw",class:{
                    'fa-check-square-o': _vm.isSelected,
                    'fa-square-o': !_vm.isSelected,
                }}),_vm._v("\n        "+_vm._s(_vm.description)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }